import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
// import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import { fetchPranthList } from './pranthService'; // Adjust path as needed
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const ADD_ARTHIKSAKHA_TO_USER = "add-arthiksakha-to-user";
const REMOVE_ARTHIKSAKHA_TO_USER = "remove-arthiksakha-from-user";

const AdminAddArthiksakhaToUser = () => {
  const back = async (e) => {
    e.preventDefault();
    // setSuccess(false);
  };
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const userRef = useRef();
  const errRef = useRef();

  const { auth } = useAuth();

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const personId = queryParams.get('person_id');
  const name = queryParams.get('name');
  const mobile = queryParams.get('mobile');
  const [error, setError] = useState(null);
  const [pranthList, setPranthList] = useState([]);
  const [selectedPranthId, setSelectedPranthId] = useState(1);
  const [arthiksakhasList, setArthiksakhasList] = useState([]);
  const [selectedArthiksakhasId, setSelectedArthiksakhasId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const ArthiksakhasOfArthiksakhaUserPerPage = 15;
  const [ArthiksakhasOfArthiksakhaUser, setArthiksakhasOfArthiksakhaUser] = useState([]);


  useEffect(() => {
    const getPranths = async () => {
      const data = await fetchPranthList(); // Get data from the service
      setPranthList(data);                  // Set data to state
    };

    getPranths();
  }, []);

  useEffect(() => {
    fetchPranthList();
  }, []);

  useEffect(() => {
    if (selectedPranthId) {
      fetchArthiksakhaList(selectedPranthId).then((vibhags) => {
        if (vibhags.length > 0) {
          setSelectedArthiksakhasId(vibhags[0].vibhag_id);
        } else {
          setSelectedArthiksakhasId("");
          setArthiksakhasList([]);
          // setError("No vibhags for selected pranth");
        }
      });
    }
  }, [selectedPranthId]);




  const fetchArthiksakhaList = async (pranthId) => {
    try {
      const res = await axiosPrivate.get(`list-arthik-sakhas?pranth_id=${pranthId}`);
      const data = Array.isArray(res.data) ? res.data : [];
      setArthiksakhasList(data);
      return data;
    } catch (err) {
      console.error("Failed to fetch Arthiksakha", err);
      setArthiksakhasList([]);
      return [];
    }
  };





  const fetchArthiksakhasOfArthiksakhaUser = useCallback(async () => {
    setError(null); // clear previous error
    try {
      const response = await axiosPrivate.get(`list-user-arthik-sakhas?person_id=${personId}`, {
        withCredentials: true,
      });
      const franchiseList = response.data;
      setArthiksakhasOfArthiksakhaUser(franchiseList);
      // setLoading(false);
    } catch (error) {
      console.error("Error fetching Arthiksakhas of Arthiksakha user:", error);
      setError(error?.response?.data?.message?.toString() || error?.message || "No Arthiksakhas of Arthiksakha user available.");
      // setLoading(false);
    }
  }, [axiosPrivate, personId]); // 👈 dependency added

  useEffect(() => {
    fetchArthiksakhasOfArthiksakhaUser();
  }, [personId]);

  const AddArthiksakhaToUserSubmit = async (e) => {
    e.preventDefault();

    try {
      var data = JSON.stringify({
        arthik_sakha_id: selectedArthiksakhasId,
        person_id: personId,

      });
      const response = await axiosPrivate.post(ADD_ARTHIKSAKHA_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);


      fetchArthiksakhasOfArthiksakhaUser();
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
    }

  };


  const RemoveArthiksakhaFromUser = async (e, selectedArthiksakhasId, personId) => {
    e.preventDefault();
    try {
      const data = JSON.stringify({
        arthik_sakha_id: selectedArthiksakhasId,
        person_id: personId
      });

      const response = await axiosPrivate.post(REMOVE_ARTHIKSAKHA_TO_USER, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      fetchArthiksakhasOfArthiksakhaUser();
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message?.msg || "Unknown error";
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Operation Failed");
      }
    }
  };


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // ensure success message is cleared
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // ensure error message is cleared
    }

    // Auto-hide after 10 seconds
    setTimeout(() => {
      setErrMsg("");
      setSucssMsg("");
    }, 10000); // 10000ms = 10 seconds
  };



  const indexOfLastArthiksakhasOfArthiksakhaUser = currentPage * ArthiksakhasOfArthiksakhaUserPerPage;
  const indexOfFirstArthiksakhasOfArthiksakhaUser = indexOfLastArthiksakhasOfArthiksakhaUser - ArthiksakhasOfArthiksakhaUserPerPage;
  const currentArthiksakhasOfArthiksakhaUser = ArthiksakhasOfArthiksakhaUser.slice(indexOfFirstArthiksakhasOfArthiksakhaUser, indexOfLastArthiksakhasOfArthiksakhaUser);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(ArthiksakhasOfArthiksakhaUser.length / ArthiksakhasOfArthiksakhaUserPerPage);

  return (
    <>
      <Container>
        {/* {success ? (
          <section>
            <h1>User successfully registred !</h1>
            <div className="flexGrow">
              <button onClick={back}>Back</button>
            </div>
          </section>
        ) : ( */}
        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>


        <section className="userregbody userregbody2">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>

          <p
            ref={errRef}
            className={sucssMsg ? "sucssmsg" : "offscreen"}
            aria-live="assertive"
          >
            {sucssMsg}
          </p>


          <div className="wrapper wrapper2 new_arthiksakha">

            <form>
              <h4 class="arthik_head">Add New Arthiksakhas to <span class="colorChange">{name}</span> </h4>

              <p className="arthik_head">Phone: {mobile}</p>
              <form onSubmit={AddArthiksakhaToUserSubmit}>
                {/* <Form.Label className="newformstyle">Select Pranth</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedPranthId}
                  onChange={(e) => {
                    const pranthId = e.target.value;
                    setSelectedPranthId(pranthId);

                    if (!pranthId) {
                      // Clear vibhag, jilla, and table if no Pranth selected
                      setArthiksakhasList([]);
                      setSelectedArthiksakhasId("");

                    }
                  }}
                > 
                <option value="">-- Select Pranth --</option>
                {pranthList.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select> */}

                <Form.Label className="newformstyle">Select Arthiksakha</Form.Label>
                <Form.Select
                  className="newselectstyle"
                  value={selectedArthiksakhasId}
                  onChange={(e) => {
                    const ArthiksaId = e.target.value;
                    setSelectedArthiksakhasId(ArthiksaId);

                    if (!ArthiksaId) {
                      // Clear Jilla list and selection if no Vibhag selected
                      // setJillaList([]);
                      // setSelectedJillaId("");

                      // setKhandList([]);
                      // setSelectedKhandId("");

                    }
                  }}
                  disabled={!arthiksakhasList.length}
                >
                  <option value="">-- Select Arthiksakhas --</option>
                  {Array.isArray(arthiksakhasList) &&
                    arthiksakhasList.map((v) => (
                      <option key={v.arthik_sakha_id} value={v.arthik_sakha_id}>
                        {v.arthik_sakha}
                      </option>
                    ))}
                </Form.Select>
              </form>



              <button
                type="button" // Important to prevent form submit
                className="btn"
                onClick={AddArthiksakhaToUserSubmit} // Call this for "Sign Up"
                disabled={!selectedArthiksakhasId}
              >
                Submit
              </button>
            </form>

          </div>

          <br></br>
          <div className="wrapperemp2">
            {/* <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Vibhag</button> */}
            <h3>List Arthiksakhas of {name}</h3>

            <div className="table-container">
              <table id="customers">
                <thead>
                  <tr>
                    <th>Jilla name</th>
                    <th>Arthiksakha name (Malayalam)</th>
                    <th>Options</th>
                  </tr>
                </thead>

                <tbody>
                  {error ? (
                    <tr>
                      <td colSpan="6" className="text-danger text-center">
                        {error}
                      </td>
                    </tr>
                  ) : ArthiksakhasOfArthiksakhaUser.length === 0 ? (
                    <tr>
                      <td colSpan="6">No Data available.</td>
                    </tr>
                  ) : (
                    currentArthiksakhasOfArthiksakhaUser.map(ArthiksakhaOfArthiksakhaUser => (
                      <tr key={ArthiksakhaOfArthiksakhaUser.arthik_sakha_id}>
                        <td>{ArthiksakhaOfArthiksakhaUser.jilla_name}</td>
                        <td>{ArthiksakhaOfArthiksakhaUser.arthik_sakha}</td>



                        <td>
                          <button class="btn btn-danger" onClick={(e) => RemoveArthiksakhaFromUser(e, ArthiksakhaOfArthiksakhaUser.arthik_sakha_id, personId)}>
                            Remove Arthiksakha
                          </button>

                        </td>
                      </tr>
                    ))
                  )}
                </tbody>


              </table>
            </div>

            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </section>
        {/* )} */}
      </Container >
    </>
  );
};

export default AdminAddArthiksakhaToUser;
